import { IPaginateProducts } from 'src/shared/common-dtos/get-all-paginate';
import ApiService from '../../../utils/base-api/api-service';
import { ICreateEmail } from './dtos/create';
import { IEmailList } from './dtos/email-list';

class EmailService extends ApiService {
  constructor() {
    super({ baseURL: '/AdminEmailAccount' });
  }

  getEmails(paginations?:IPaginateProducts): Promise<IEmailList> {
    return this.post('/List',undefined,{
      params:paginations
    });
  }

  markEmailAsDefault(id: string) {
    return this.post('/MarkAsDefaultEmail', {}, { params: { id } });
  }

  createEmail(payload: ICreateEmail) {
    return this.post('/Create', payload);
  }


  updateEmail(payload: ICreateEmail) {
    return this.post('/Edit', payload);
  }

  deleteEmail(deleteId: string) {
    return this.post('/Delete', undefined, {
      params: {
        id: deleteId
      }
    });
  }


  sendEmailTest(payload: ICreateEmail) {
    return this.post('/SendTestEmail', payload);
  }

  changeEmailPassword(payload: ICreateEmail) {
    return this.post('/ChangePassword', payload);
  }


  getEmailAccountById(accountId: string) {
    return this.get('/getEmailAccountById', {
      params: {
        id: accountId
      }
    });
  }





}

export const emailService = new EmailService();
